<ng-template #selectedTemplate let-item="item">
    <div class="forms-phone-input__option" *ngIf="item && item.Code">
        <div class="forms-phone-input__option-label -for-flag">
            <img src="./assets/images/flags/{{item.Code | lowercase}}.png" [alt]="item.Code">
        </div>
        <div class="forms-phone-input__option-label -for-prefix">+{{item.PhonePrefix}}</div>
    </div>
</ng-template>

<ng-template #optionTemplate let-item="item">
    <div class="forms-phone-input__option -for-list" *ngIf="item && item.Code">
        <div class="forms-phone-input__option-label -for-flag">
            <img src="./assets/images/flags/{{item.Code | lowercase}}.png" [alt]="item.Code">
        </div>
        <div class="forms-phone-input__option-label -for-country">{{item.Name}}</div>
        <div class="forms-phone-input__option-label -for-prefix -dimmed">+{{item.PhonePrefix}}</div>
    </div>
</ng-template>

<shared-forms-inputs-group class="forms-phone-input" [label]="label" [single]="!(showCountries$ | async)">
    <shared-forms-input selectWidth="dynamic" [placeholder]="placeholder" [showHint]="false" *ngIf="(showCountries$ | async)"
        class="forms-phone-input__field -for-country-prefix" [name]="countryName" [compact]="compact"
        [selectOptions]="(countries$ | async)" type="select" [parentForm]="parentForm" [optionTemplate]="optionTemplate"
        [selectedTemplate]="selectedTemplate" [defaultSelected]="defaultSelected"
        [onSelectUpdateRevalidatedFields]="onSelectUpdateRevalidatedFields">
    </shared-forms-input>

    <shared-forms-input [placeholder]="placeholder" class="forms-phone-input__field -for-cell-number"
        [compact]="compact" [parentForm]="parentForm" [name]="mobileName" type="text" pattern="[0-9]*"
        inputmode="numeric" (onButtonClick)="handleErrorButtonClick($event)">
    </shared-forms-input>
</shared-forms-inputs-group>
